import { PgPalette } from '../../core/ui/palette';

export interface PgFlagNotificationOptions {
  enterSide?: 'left' | 'right';
  maxWidth?: number;
  color?: PgPalette;
  bold?: boolean;
  timeout?: number;
  bottom?: number;
}
export class DefaultPgFlagNotificationOptions {
  enterSide: 'left' | 'right' = 'left';
  maxWidth = 400;
  color: PgPalette = 'info';
  bold = false;
  timeout = 3000;
  bottom = 8;
  constructor(color?, side?, timeout?, bottom?) {
    if (bottom) {
      this.bottom = bottom;
    }
    if (color) {
      this.color = color;
    }
    if (side) {
      this.enterSide = side;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }
}
